import { FC } from "react";
import {
  ALERT_DEFAULTS,
  ALERT_TITLE_ROW_START_CLASS_MAP,
  TAlertTitleProps,
} from "./Alert.config";
import { TextSubtitle } from "../../typography/TextSubtitle";
import { cn } from "@/ui/lib";
import { getAlertCopyColumnClass } from "./Alert.utils";

export const AlertTitle: FC<TAlertTitleProps> = ({ title, asset, orientation = ALERT_DEFAULTS.orientation }) => (
  <div
    data-component="AlertTitle"
    className={cn(
      getAlertCopyColumnClass(asset),
      ALERT_TITLE_ROW_START_CLASS_MAP[orientation],
    )}
  >
    <TextSubtitle size={2} isResponsive={false}>{ title }</TextSubtitle>
  </div>
);
